import { TRACK_DRIVER } from '@/constants/apiRoutes';
import { post } from '@/utilities/onwardClient';

export const trackDriver = async (payload) => {
    return post(TRACK_DRIVER, payload);
};
